import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
//
//
const API_KEY = process.env.REACT_APP_API_KEY as string;
//
export const apiSlice = createApi({
  reducerPath: "apiSliceGeneric",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_HOST}`,
    prepareHeaders: (headers) => {
      headers.set("X-API-KEY", API_KEY);
      return headers;
    },
  }),
  tagTypes: ["brandlist"],
  endpoints: (builder) => ({
    getBrandList: builder.query<any, void>({
      query: () => "/showroom/api/v1/brand/all",
      keepUnusedDataFor: 900,
      transformResponse: (response: any) => response.data,
      providesTags: ["brandlist"],
    }),
    // 
  }),
});

//
export const { useGetBrandListQuery } = apiSlice;
